module.exports = __webpack_public_path__ + "static/img/2.321125df.png";